import { render, staticRenderFns } from "./ns-crud.vue?vue&type=template&id=405366e9&"
import script from "./ns-crud.vue?vue&type=script&lang=ts&"
export * from "./ns-crud.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports